<template lang="pug">
div.app-body-inner(style="margin-top:160px;")
    div.row-col.row-col-xs.b-b
        div.col-sm-2.col-md-2.w.w-auto-sm.b-r.box
            div.row-col
                div.row-row
                    div.row-body.scrollable.hover
                        div.row-inner.padding.pos-rlt
                            span._300.block.p-b-sm.m-l-xs.text-md Settings
                            div.nav-active-primary
                                div.nav.nav-pills.nav-sm
                                    setting-tabs(
                                        @tab-changed="switchTab",
                                        :current-tab="currentTab",
                                    )

        keep-alive
            component(
                v-bind:is="currentTab"
            )
</template>

<script>
import outletTarget from './target/outlet-target.vue';
import settingTabs from './setting-tabs.vue';
import centralSettings from './central-settings/central-settings.vue';

const tabs = ['loyalty'];

export default {
    components: {
        outletTarget,
        settingTabs,
        centralSettings,
    },

    props: {
        tab: {
            type: String,
            default: null,
        },
    },

    data() {
        return {
            currentTab: 'null',
        };
    },

    computed: {
        hasTab() {
            if (_.isNull(this.tab)) return false;

            if (tabs.indexOf(this.tab) < 0) return false;

            return true;
        },

        loading() {
            return this.onLoading('load settings');
        },
    },

    created() {
        this.startLoading('load settings');
        this.setTab(this.hasTab ? this.tab : 'outlet-target');
    },

    methods: {
        switchTab(tab) {
            if (this.loading) {
                return;
            }

            this.setTab(tab);
        },

        setTab(tab) {
            this.currentTab = tab;
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/setting/settings.vue